import { game } from "../Game";
import { Settings } from "../Settings";
import * as PIXI from 'pixi.js';
import * as PhysicsParticleEmitter from './PhysicsParticleEmitter';
import { adoptChunks, tearChunks } from './gore/goreChunks';

const vec1 = new Box2D.b2Vec2(0, 0);

const randomMeat = () => `Gore_Meat${Math.floor(Math.random() * 6) + 1}0000`;

export const  generateGoreParticles = (targetBodyPart, sprite, position, angle, velocity, noExtraGore) => {
    if(!Settings.goreEnabled) return;
    let meatParticles = ["Gore_Meat", "Gore_Meat", "Gore_Meat"];
    let extraParticles = [];
    // Pieces torn from the part's own art.
    let skinChunks = 0;
    switch(targetBodyPart){
        case 'head':
            extraParticles.push('Gore_Brain');
            skinChunks = 2;
            meatParticles.push("Gore_Meat", "Gore_Meat");
        break
        case 'body':
            extraParticles.push('Gore_LungRight', 'Gore_LungLeft', 'Gore_Stomach','Gore_Liver');
            skinChunks = 2;
            meatParticles.push("Gore_Meat", "Gore_Meat","Gore_Meat", "Gore_Meat");
        break;
        case 'belly':
            extraParticles.push('Gore_Intestine');
            skinChunks = 1;
        break;
        case 'thigh_left':
        case 'thigh_right':
            skinChunks = 1;
            meatParticles.push("Gore_Meat");
        break;
        case 'leg_left':
        case 'leg_right':
            skinChunks = 1;
            meatParticles.push("Gore_Meat");
        break;
        case 'hand_left':
        case 'hand_right':
            meatParticles = ['Gore_Meat'];
        break;
        case 'feet_left':
        case 'feet_right':
            meatParticles = ['Gore_Meat', 'Gore_Meat'];
        break;
        case 'shoulder_left':
        case 'shoulder_right':
            skinChunks = 1;
        break;
        case 'arm_left':
        case 'arm_right':
            skinChunks = 1;
        break;
    }

    if(noExtraGore){
        extraParticles.length = 0;
        skinChunks = 0;
        // NO EXTRA GORE FOR KIDS & BABY
    }

    const particlesToGenerate = meatParticles.concat(extraParticles);
    const goreParticleMaxSpeed = 50;

    const targetChildIndex = sprite.parent.getChildIndex(sprite);

    for(let i = 0; i< particlesToGenerate.length; i++){
        const particle = particlesToGenerate[i];
        if(particle === 'Gore_Meat'){
            particlesToGenerate[i] = randomMeat();
        }else {
            particlesToGenerate[i] = particlesToGenerate[i] + '0000';
        }
    }

    const body = sprite.myBody;
    const chunks = skinChunks && body ? tearChunks(body, targetBodyPart, skinChunks) : [];
    // A part with no art to tear throws meat instead.
    while (chunks.length < skinChunks) chunks.push(randomMeat());
    particlesToGenerate.push(...chunks);

    const sprites = PhysicsParticleEmitter.emit(particlesToGenerate, position, particlesToGenerate.length, 5, goreParticleMaxSpeed, false, undefined, angle, undefined, velocity,  targetChildIndex, false);
    if(chunks.length) adoptChunks(particlesToGenerate, sprites);
}
